export default "__VITE_ASSET__CrBjBdlP__"